<file-pond #myPond [options]="pondOptions" [files]="pondFiles"></file-pond>